import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import type { PublicClientApplication } from '@azure/msal-browser';

export interface RouterContext {
  queryClient: QueryClient;
  msalInstance: PublicClientApplication;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return <Outlet />;
}
